import { useContext, useEffect, useRef, useState } from 'react';

import { AgGridReact } from 'ag-grid-react';
import { cloneDeep } from 'lodash';
import { useSearchParams } from 'react-router-dom';

import { useGetCsrDay7Query } from '@/app/services/excel';
import { useDefaultGridOptions } from '@/grid';
import { defaultColDef } from '@/grid/defaults';
import { TOG_CsrDay7 } from '@/rtk-query.gql';
import { PrimaryContext } from '@/services';

import { csrDay7RecipSummaryColDefs } from './columnDefs';
import { TransformDataToRecipSummary } from './ProcessRecipSummaryData';
import { RecipSummaryRow } from './types';

export const RecipSummaryPage = () => {
  const defaultGridOptions = useDefaultGridOptions();
  const { themeMode } = useContext(PrimaryContext);
  const gridRef = useRef<AgGridReact>(null);

  const [params] = useSearchParams();
  const beginDate = params.get('beginDate');
  const endDate = params.get('endDate');
  const siteId = params.get('site');
  const accountId = params.get('account');

  const [rowData, setRowData] = useState<TOG_CsrDay7[]>([]);
  const [summaryData, setSummaryData] = useState<RecipSummaryRow[]>([]);
  const [grandTotal, setGrandTotal] = useState<number>(0);

  const { data: csrDay7Data } = useGetCsrDay7Query(
    {
      beginDate,
      endDate,
      siteId,
      accountId,
    },
    { skip: !beginDate || !endDate },
  );

  useEffect(() => {
    if (csrDay7Data) {
      setRowData(cloneDeep(csrDay7Data));
    }
  }, [csrDay7Data]);

  useEffect(() => {
    if (rowData.length) {
      const { summaryRows, total } = TransformDataToRecipSummary(rowData);
      setSummaryData(summaryRows);
      setGrandTotal(total);
    }
  }, [rowData]);

  return (
    <div className="common-page">
      <div className="csrDay7__filters">
        <div className="filter-group">
          <div className="grand-total">
            <span className="grand-total-label">
              Total Implanted Purchased Pregnancy:
            </span>
            <span className="grand-total-value">{grandTotal}</span>
          </div>
        </div>
      </div>
      <div className="csrDay7__recip-summary-grid">
        <AgGridReact
          gridOptions={defaultGridOptions}
          className={`ag-theme-transova${themeMode === 'dark' ? '-dark' : ''}`}
          defaultColDef={defaultColDef}
          columnDefs={csrDay7RecipSummaryColDefs}
          rowData={summaryData}
          ref={gridRef}
          animateRows={false}
          rowDragMultiRow={true}
          rowDragManaged={true}
        />
      </div>
    </div>
  );
};
